import { ChapterListResponseChapterGenerationStatusEnum, ChapterResponse } from '@goldcast/api/content';
import { SpeakerWithDetails } from '@goldcast/player-config/src/types/speaker-types';
import { Word } from '@goldcast/player-config/src/types/transcript-types';

export enum ChapterGenerationStatus {
  DONE = 'DONE',
  FAILED = 'FAILED',
  NOT_STARTED = 'NOT_STARTED',
  PROCESSING = 'PROCESSING'
}

export interface TranscriptContextData {
  transcript: Word[];
  end: number;
  speakersWithDetails: Record<string, SpeakerWithDetails>;
  usedSpeakers: SpeakerWithDetails[];
  chapterData: ChapterResponse[] | undefined;
  chapterGenerationStatus: ChapterListResponseChapterGenerationStatusEnum;
  chaptersLastUpdatedAt: string | null;
  timeSrtIndexArray: {
    startTime: number;
    srtIndex: number;
  }[];
  isTranscriptInitialized: boolean;
}
